export default __webpack_public_path__ + "static/media/10n.7b1a5dd8.jpg";